<template>
  <div>
    <!-- 报告 -->
    <template v-if="Folderkeys == -11.1">
      <el-row>
        <el-col :span="4" class="flex-items">
          <div class="tui-rowTitle">学届：</div>
          <el-select
            v-model="levelListValue"
            placeholder="请选择学届"
            @visible-change="StudyYearSelectResult"
            @change="onSelectLevel"
          >
            <el-option
              v-for="item in levelList"
              :key="item.Id"
              :label="item.Name"
              :value="item.Id"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="4" class="flex-items">
          <div class="tui-rowTitle">年级：</div>
          <el-select
            :popper-append-to-body="true"
            v-model="gradeValue"
            placeholder="请选择"
            @change="onSelectGrade"
          >
            <el-option
              v-for="item in gradeList"
              :key="item.Id"
              :label="item.Name"
              :value="item.Id"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="4" class="flex-items">
          <div class="tui-rowTitle">班级：</div>
          <el-select
            v-model="classListValue"
            placeholder="请选择"
            @visible-change="GetClassSelect"
            @change="onClassSelect"
          >
            <el-option
              v-for="item in classList"
              :key="item.Id"
              :label="item.Name"
              :value="item.Id"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="4" style="margin-left: 10px">
          <el-button type="goon" @click="GetCloudFileByFolderId"
            >查询</el-button
          >
          <el-button type="goon" @click="onEmpty">清空</el-button>
        </el-col>
      </el-row>
      <el-table
        :data="fileList"
        style="width: 100%; margin-top: 20px"
        border
        stripe
      >
        <el-table-column prop="FileName" label="报告名称" align="center">
        </el-table-column>
        <el-table-column prop="CreateTime" label="上传时间" align="center">
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button type="text" @click="wenDangDload(scope.row)"
              >下载</el-button
            >
            <el-button
              type="text"
              style="color: #e14747"
              @click="removeFile(scope.row, scope.$index)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </template>
    <!-- 课件 -->
    <template v-if="Folderkeys == -12.1">
      <el-table :data="fileList" style="width: 100%" border stripe>
        <el-table-column prop="FileName" label="课件名称" align="center">
        </el-table-column>
        <el-table-column prop="CreateTime" label="上传时间" align="center">
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button type="text" @click="wenDangDload(scope.row)"
              >下载</el-button
            >
            <el-button
              type="text"
              style="color: #e14747"
              @click="removeFile(scope.row, scope.$index)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </template>
    <!-- 自定义文件夹 -->
    <template v-if="Folderkeys != -12.1 || Folderkeys != -11.1">
      <el-table :data="fileList" style="width: 100%" border stripe>
        <el-table-column prop="FileName" label="内容名称" align="center">
        </el-table-column>
        <el-table-column prop="CreateTime" label="上传时间" align="center">
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button type="text" @click="wenDangDload(scope.row)"
              >下载</el-button
            >
            <el-button
              type="text"
              style="color: #e14747"
              @click="removeFile(scope.row, scope.$index)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </template>
    <div class="tui-add" v-if="Folderkeys != -11.1">
      <input
        @input="addFileChange"
        multiple="multiple"
        type="file"
        name=""
        id=""
      />
      <img src="../../assets/cloud-add.png" alt="" />
    </div>
  </div>
</template>
<script>
import {
  GetCloudFileByFolderId,
  AddCloudFile,
  UploadFile,
  DeleteCloudFile,
  getAcademicSelect,
  GetClassSelect,
  GetGradeList,
} from "../../api/api";
import download from "../../downLoad";
import JSZip from "jszip";
import FileSaver from "file-saver";
export default {
  data() {
    return {
      userInfo: {},
      Folderkeys: 0,
      fileList: [],
      levelList: [],
      levelListValue: null,
      gradeList: [],
      gradeValue: null,
      classList: [],
      classListValue: null,
      gradeId: 0,
    };
  },
  created() {
    this.userInfo = JSON.parse(window.localStorage.user);
    this.Folderkeys = this.$route.query.Folderkeys;
    this.GetCloudFileByFolderId();
  },
  methods: {
    //  删除文件提示
    removeFile(item, index) {
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          let xhr = await DeleteCloudFile({
            ids: [item.Id],
          });
          if (xhr.status == 200 && xhr.data.success) {
            this.$message({
              message: "删除成功",
              type: "success",
            });
            this.GetCloudFileByFolderId();
          } else {
            this.$message({
              message: "删除失败",
              type: "error",
            });
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 下载单个文件
    wenDangDload(item) {
      let idx = item.FileUrl.lastIndexOf(".");
      if (idx != -1) {
        let ext = item.FileUrl.substr(idx + 1).toUpperCase();
        ext = ext.toLowerCase();
        this.downloadfile(item.FileUrl, item.FileName, ext);
      }
    },
    downloadfile(url, strFileName, strMimeType) {
      var xmlHttp = null;
      if (window.ActiveXObject) {
        // IE6, IE5 浏览器执行代码
        xmlHttp = new ActiveXObject("Microsoft.XMLHTTP");
      } else if (window.XMLHttpRequest) {
        // IE7+, Firefox, Chrome, Opera, Safari 浏览器执行代码
        xmlHttp = new XMLHttpRequest();
      }
      //2.如果实例化成功，就调用open（）方法：
      if (xmlHttp != null) {
        xmlHttp.open("get", url, true);
        xmlHttp.responseType = "blob"; //关键
        xmlHttp.send();
        xmlHttp.onreadystatechange = doResult; //设置回调函数
      }
      function doResult() {
        if (xmlHttp.readyState == 4) {
          //4表示执行完成
          if (xmlHttp.status == 200) {
            //200表示执行成功

            download(xmlHttp.response, strFileName, strMimeType);
          }
        }
      }
    },
    addFileChange(event) {
      let file = event.target.files;
      this.addFile(file);
    },
    // 上传云文件
    async addFile(flie) {
      if (!flie.length) {
        return;
      }
      const loading = this.$loading({
        lock: true,
        text: "上传中。。。。。",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

      let result = [];
      let size = 0;
      try {
        for (let index = 0; index < flie.length; index++) {
          const element = flie[index];
          //定义FormData对象 存储文件
          let mf = new FormData();
          //将图片文件放入mf
          mf.append("file", element);

          let xhr = await UploadFile(mf);
          if (xhr.status == 200 && xhr.data.success) {
            size += element.size;

            result.push({
              fileUrl: xhr.data.response,
              FileName: element.name,
            });
          }
        }
      } catch (error) {
        // this.$message({
        //   message: "上传失败",
        //   type: "error",
        // });
      }
      let type = 4;
      if (this.Folderkeys == -11.1) {
        //报告
        type = 4;
      } else if (this.Folderkeys == -12.1) {
        //课件
        type = 3;
      } else {
        type = 19;
      }

      let addXhr = await AddCloudFile({
        Storage: Math.round(size / 1024),
        IsTeacher: this.userInfo.UserIdentity.indexOf("2") != -1 ? 1 : 0,
        SchoolId: this.userInfo.SchoolId,
        type: type,
        cloudFileInfoList: result,
        pictureType: 3,
        kindergarten: this.userInfo.uRealName, //学校
        Dimension:
          this.Folderkeys <= 0 ? Math.floor(Math.abs(this.Folderkeys)) : 19,
        Mu_Cloud_File_TypeId:
          this.Folderkeys <= 0 ? undefined : Number(this.Folderkeys),
      });
      if (addXhr.status == 200 && addXhr.data.success) {
        this.GetCloudFileByFolderId();
        this.$message({
          message: "上传成功",
          type: "success",
        });
      } else {
        this.$message({
          message: "上传失败",
          type: "error",
        });
      }
      loading.close();
    },
    //   清空
    onEmpty() {
      this.levelListValue = null;
      this.gradeValue = null;
      this.classListValue = null;
      this.GetCloudFileByFolderId();
    },
    async GetCloudFileByFolderId() {
      let type = 4;
      if (this.Folderkeys == -11.1) {
        //报告
        type = 4;
      } else if (this.Folderkeys == -12.1) {
        //课件
        type = 3;
      }
      this.fileList = [];

      let xhr = await GetCloudFileByFolderId({
        IsTeacher: this.userInfo.UserIdentity.indexOf("2") != -1 ? 1 : 0,
        Dimension:
          this.Folderkeys <= 0 ? Math.floor(Math.abs(this.Folderkeys)) : 19,
        Mu_Cloud_File_TypeId:
          this.Folderkeys <= 0 ? undefined : this.Folderkeys,
        SchoolId: this.userInfo.SchoolId,
        StudyYearId: this.levelListValue,
        gradeId: this.gradeValue,
        classId: this.classListValue,
      });

      if (xhr.status == 200 && xhr.data.success) {
        xhr.data.response.forEach((element) => {
          element.isCheck = false;
          let flieNameArr = element.FileUrl.split("/");
          element.flieName = flieNameArr[flieNameArr.length - 1];
        });

        this.fileList = xhr.data.response;
        if (this.fileList.length == 0) {
          this.isNoDate = true;
        } else {
          this.isNoDate = false;
        }
      } else {
        this.isNoDate = true;
      }
    },
    //   清空
    onEmpty() {
      this.levelListValue = null;
      this.gradeValue = null;
      this.classListValue = null;
      this.GetCloudFileByFolderId();
    },
    // 年级下拉
    async GetGradeList() {
      let res = await GetGradeList({
        SchoolId: this.userInfo.SchoolId,
        studyYearId: this.studyYearId,
        Uid: this.userInfo.uID,
      });

      if (res.data.success) {
        this.gradeList = res.data.response;
      }
    },
    async GetClassSelect() {
      let res = await GetClassSelect({
        SchoolId: this.userInfo.SchoolId,
        Uid: this.userInfo.uID,
        StudyYearId: Number(this.levelListValue),
        gradeId: this.gradeId,
      });
      if (res.data.success) {
        this.classList = res.data.response;
      }
    },
    onClassSelect(val) {
      this.PageIndex = 1;
      this.classId = val;
    },
    async onSelectGrade(val) {
      this.PageIndex = 1;
      this.gradeId = val;
      await this.GetClassSelect();
    },
    onSelectLevel(e) {
      this.levelListValue = e;
      this.gradeList = [];
      this.gradeValue = null;
      this.classList = [];
      this.classListValue = null;
      this.GetGradeList();
    },
    //   学届下拉
    async StudyYearSelectResult() {
      let res = await getAcademicSelect({
        SchoolId: this.userInfo.SchoolId,
        Uid: this.userInfo.uID,
      });
      if (res.data.success) {
        this.levelList = res.data.response;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.el-button--goon {
  color: #fff;
  background-color: #5474e6;
  border-color: #5474e6;
  height: 34px;
  line-height: 34px;
  padding: 0 20px;
}
.tui-rowTitle {
  margin-left: 10px;
}
.tui-add {
  position: fixed;
  bottom: 53px;
  right: 102px;
  input {
    cursor: pointer;
    display: block;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0;
  }
}
</style>